import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

import { getDeviceStyles } from '../../styles/tab/getDeviceStyles';
import { getTheme } from '../../styles/tab/getTheme';
import { TTabsTheme } from '../../types';

export interface ITabProps {
  title: number | string;
  disabled?: boolean;
  active?: boolean;
  focusVisible: boolean;
  onClick(e: React.MouseEvent): void;
  theme: TTabsTheme;
}

export const Tab = ({ title, disabled, active, focusVisible, onClick, theme }: ITabProps): React.JSX.Element => {
  const deviceType = useDeviceType();
  const styles = getDeviceStyles(deviceType);
  const themeStyles = getTheme(theme);

  return (
    <button
      disabled={disabled}
      type="button"
      role="tab"
      aria-selected={active}
      tabIndex={active ? 0 : -1}
      className={clsx(
        styles['tab'],
        themeStyles['tab'],
        active && styles['active'],
        focusVisible && styles['focus-visible'],
      )}
      onClick={onClick}
    >
      <span className={styles['text']}>{title}</span>
    </button>
  );
};
